// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-height{min-height:58px;padding-top:0;padding-bottom:0}.logo{width:210px}@media screen and (max-width:328px){.logo{width:190px}}@media screen and (max-width:500px){.menuItems{margin:.5em!important}}", ""]);
// Exports
module.exports = exports;
